import { createStore, combineReducers } from 'redux';
import formReducer from './reducers/formReducer';
const rootReducer = combineReducers(
    { formData: formReducer }
);
const configureStore = () => {
    return createStore(rootReducer);
}
export default configureStore;